const React = require("react")
const ReactDOM = require("react-dom")
const {
  EnhancementReporterButton,
  EnhancementReporterDialog,
  EnhancementReporterProvider,
} = require("@handrail/enhancement-reporter/react")
const {
  enhancementReporterAppearance,
  ENHANCEMENT_REPORTER_HEADING,
} = require("../support/handrail_enhancement_reporter_appearance")

function EnhancementReporterLauncher({ launcher }) {
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    if (!launcher) return
    const showDialog = (event) => {
      event.preventDefault()
      setOpen(true)
    }
    launcher.addEventListener("click", showDialog)
    return () => launcher.removeEventListener("click", showDialog)
  }, [launcher])

  const dialogProps = {
    heading: ENHANCEMENT_REPORTER_HEADING,
    appearance: enhancementReporterAppearance(),
  }

  if (launcher) {
    return React.createElement(EnhancementReporterDialog, {
      ...dialogProps,
      open,
      onClose: () => {
        setOpen(false)
        document.querySelector("#handrail-menu summary")?.focus()
      },
    })
  }

  return React.createElement("div", {
    style: { position: "fixed", right: "1rem", bottom: "1rem", zIndex: 1100 },
  }, React.createElement(EnhancementReporterButton, {
    ...dialogProps,
    label: "Suggest an enhancement",
  }))
}

function sameOriginFetch(input, options = {}) {
  const headers = new Headers(options.headers || {})
  const method = String(options.method || "GET").toUpperCase()
  const csrfToken = document.querySelector("meta[name='csrf-token']")

  if (!["GET", "HEAD"].includes(method) && csrfToken) {
    headers.set("X-CSRF-Token", csrfToken.content)
  }

  return window.fetch(input, { ...options, headers })
}

function mountEnhancementReporter() {
  const root = document.getElementById("handrail-enhancement-reporter")
  if (!root) return
  const sessionKey = root.dataset.sessionKey || ""
  if (root.dataset.mounted === "true" && root.dataset.mountedSessionKey === sessionKey) return

  root.dataset.mounted = "true"
  root.dataset.mountedSessionKey = sessionKey
  ReactDOM.render(
    React.createElement(
      EnhancementReporterProvider,
      {
        // Public identity only; the raw session remains in the HttpOnly cookie.
        sessionKey,
        config: {
          endpoint: "/api/handrail-enhancements",
          appVersion: root.dataset.appVersion,
          fetch: sameOriginFetch,
        },
      },
      React.createElement(EnhancementReporterLauncher, {
        launcher: document.getElementById("handrail-enhancement-report-link"),
      }),
    ),
    root,
  )
}

function unmountEnhancementReporter() {
  const root = document.getElementById("handrail-enhancement-reporter")
  if (!root || root.dataset.mounted !== "true") return

  ReactDOM.unmountComponentAtNode(root)
  delete root.dataset.mounted
  delete root.dataset.mountedSessionKey
}

document.addEventListener("DOMContentLoaded", mountEnhancementReporter)
document.addEventListener("turbolinks:load", mountEnhancementReporter)
document.addEventListener("turbolinks:before-cache", unmountEnhancementReporter)
document.addEventListener("turbolinks:before-render", unmountEnhancementReporter)

document.addEventListener("click", (event) => {
  const menu = document.getElementById("handrail-menu")
  if (menu && (!menu.contains(event.target) || event.target.closest("a"))) {
    menu.open = false
  }
})
document.addEventListener("keydown", (event) => {
  const menu = document.getElementById("handrail-menu")
  if (event.key === "Escape" && menu?.open) {
    menu.open = false
    menu.querySelector("summary").focus()
  }
})
document.addEventListener("turbolinks:before-cache", () => {
  const menu = document.getElementById("handrail-menu")
  if (menu) menu.open = false
})
